"use client";

import { useState } from "react";

import { useRouter } from "next/navigation";

import { Loader2, ShieldCheck } from "lucide-react";

/** ⚠️ Mismas credenciales que `admin.vecipp.com` (tabla `panel_admin`), sesión propia de este panel. */
export function FormularioEntrar() {
  const router = useRouter();
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  async function entrar(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setEntrando(true);
    try {
      const res = await fetch("/api/entrar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, clave }),
      });
      const d = (await res.json().catch(() => null)) as { error?: string } | null;
      if (!res.ok) {
        setError(d?.error ?? "No se pudo entrar.");
        return;
      }
      router.push("/");
      router.refresh();
    } catch {
      setError("Sin conexión.");
    } finally {
      setEntrando(false);
    }
  }

  return (
    <main className="flex min-h-dvh items-center justify-center px-4">
      <form onSubmit={entrar} className="flex w-full max-w-sm flex-col gap-4 rounded-2xl bg-card p-6 shadow-sm">
        <div className="flex flex-col items-center gap-2 pb-1 text-center">
          <span className="flex size-11 items-center justify-center rounded-full bg-primary/10 text-primary">
            <ShieldCheck className="size-5" aria-hidden="true" />
          </span>
          <h1 className="font-bold text-lg">Panel de control</h1>
          <p className="text-muted-foreground text-xs leading-relaxed">
            Uso interno del equipo de Vecipp. Mismas credenciales del panel de administración.
          </p>
        </div>

        <label className="flex flex-col gap-1.5">
          <span className="font-semibold text-sm">Usuario</span>
          <input
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            autoComplete="username"
            className="rounded-xl border bg-transparent px-3 py-2.5 outline-none focus:border-primary"
          />
        </label>

        <label className="flex flex-col gap-1.5">
          <span className="font-semibold text-sm">Contraseña</span>
          <input
            type="password"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            autoComplete="current-password"
            className="rounded-xl border bg-transparent px-3 py-2.5 outline-none focus:border-primary"
          />
        </label>

        {error ? (
          <p className="rounded-lg bg-destructive/10 px-3 py-2 font-medium text-destructive text-sm" role="alert">
            {error}
          </p>
        ) : null}

        <button
          type="submit"
          disabled={entrando}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-primary font-semibold text-primary-foreground disabled:opacity-60"
        >
          {entrando ? <Loader2 className="size-4 animate-spin" aria-hidden="true" /> : null}
          {entrando ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </main>
  );
}
